import { t, tf } from "./i18n.js";
// ---------------------------------------------------------------------------
// Setup-Baukasten: eine Zeile, eine Einstellung
//
// Heute erfindet jeder Spielmodus seinen eigenen Einrichtungsbildschirm -
// secure-setup-screen hat 262 Zeilen ohne eine einzige Beschriftung,
// rtw-setup-screen 68 Zeilen mit einem Dropdown. Kein zweiter sieht aus wie
// der erste, und ein neuer Modus bedeutet jedes Mal einen Neubau.
//
// Hier steht das gemeinsame Muster: Beschriftung links, alle Optionen als
// Segmentleiste rechts. Bei drei bis sechs Werten ist ein Dropdown die
// schlechtere Wahl - man sieht weder die Alternativen noch den aktuellen
// Stand, ohne es zu oeffnen. Erst ab etwa acht Optionen lohnt eine Liste.
//
// Wichtig fuer die Umstellung: Die Segmentleiste schreibt ihren Wert in ein
// verstecktes <input> mit der URSPRUENGLICHEN Element-ID. Damit liest
// startLocal501Game() weiterhin document.getElementById("start-score-501")
// .value und muss nicht angefasst werden. Das haelt den Umbau auf HTML und
// CSS begrenzt.
//
// Markup:
//   <div class="setup-row">
//     <span class="setup-label">Start-Score</span>
//     <div class="setup-options" data-setup-target="start-score-501">
//       <button type="button" data-value="301">301</button>
//       <button type="button" data-value="501" data-default>501</button>
//     </div>
//   </div>
//   <input type="hidden" id="start-score-501" value="501" />
// ---------------------------------------------------------------------------

function setupOptionsSelect(group, value, notify = true) {
  const targetId = group.dataset.setupTarget;
  const target = targetId ? document.getElementById(targetId) : null;

  let gewaehlt = null;
  group.querySelectorAll("button[data-value]").forEach((button) => {
    const aktiv = button.dataset.value === String(value);
    button.classList.toggle("active", aktiv);
    button.setAttribute("aria-checked", aktiv ? "true" : "false");
    if (aktiv) gewaehlt = button;
  });

  if (!gewaehlt) return false;
  // Mobil-Dropdown synchron halten (eine Auswahl, zwei Darstellungen)
  const dropdown = group.parentElement?.querySelector(
    `select.setup-dropdown[data-for="${group.dataset.setupTarget}"]`
  );
  if (dropdown && dropdown.value !== String(value)) dropdown.value = String(value);
  if (target && target.value !== String(value)) {
    target.value = String(value);
    // Andere Module hoeren teils auf change - etwa um Vorschauen
    // nachzuziehen. Ein verstecktes Feld feuert das nicht von selbst.
    if (notify) target.dispatchEvent(new Event("change", { bubbles: true }));
  }
  return true;
}

function initSetupOptions(root = document) {
  root.querySelectorAll(".setup-options[data-setup-target]").forEach((group) => {
    if (group.dataset.ready) return;
    group.dataset.ready = "1";
    group.setAttribute("role", "radiogroup");

    group.querySelectorAll("button[data-value]").forEach((button) => {
      button.setAttribute("role", "radio");
    });

    // MOBIL: Dieselbe Auswahl als natives Dropdown. Auf schmalen
    // Bildschirmen brauchen 3-5 Knoepfe zwei Zeilen und brechen unschoen
    // um (Befund 07.08.2026); ein <select> nutzt den Platz und bringt
    // das native Auswahlrad des Geraets mit. Sichtbarkeit regelt CSS -
    // Desktop sieht die Knoepfe, Mobil das Dropdown.
    const dropdown = document.createElement("select");
    dropdown.className = "setup-dropdown";
    dropdown.dataset.for = group.dataset.setupTarget;
    dropdown.setAttribute("aria-label", t("js.setupkit.001"));
    group.querySelectorAll("button[data-value]").forEach((button) => {
      const option = document.createElement("option");
      option.value = button.dataset.value;
      option.textContent = button.textContent.trim();
      dropdown.appendChild(option);
    });
    dropdown.addEventListener("change", () =>
      setupOptionsSelect(group, dropdown.value)
    );
    group.after(dropdown);

    group.addEventListener("click", (event) => {
      const button = event.target.closest("button[data-value]");
      if (!button || !group.contains(button)) return;
      setupOptionsSelect(group, button.dataset.value);
    });

    // Pfeiltasten, damit die Leiste ohne Maus bedienbar bleibt
    group.addEventListener("keydown", (event) => {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      const buttons = [...group.querySelectorAll("button[data-value]")];
      const jetzt = buttons.findIndex((b) => b.classList.contains("active"));
      const schritt = event.key === "ArrowRight" ? 1 : -1;
      const naechste =
        buttons[(jetzt + schritt + buttons.length) % buttons.length];
      if (naechste) {
        setupOptionsSelect(group, naechste.dataset.value);
        naechste.focus();
        event.preventDefault();
      }
    });

    // Startwert: was im versteckten Feld steht, sonst data-default,
    // sonst die erste Option. So bleibt eine vorhandene Auswahl erhalten,
    // wenn der Bildschirm erneut geoeffnet wird.
    const target = document.getElementById(group.dataset.setupTarget);
    const vorgabe =
      group.querySelector("button[data-default]")?.dataset.value ??
      group.querySelector("button[data-value]")?.dataset.value;
    const start = target?.value || vorgabe;
    if (start !== undefined) setupOptionsSelect(group, start, false);
  });
}

if (typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initSetupOptions());
  } else {
    initSetupOptions();
  }
}

Object.assign(window, { initSetupOptions, setupOptionsSelect });

export { initSetupOptions, setupOptionsSelect };
